import { useTranslation } from 'react-i18next';

interface ConsignmentIdDisplayProps {
  consignmentId: string;
}

export function ConsignmentIdDisplay({ consignmentId }: ConsignmentIdDisplayProps) {
  const { t } = useTranslation();

  return (
    <div>
      <div className="text-sm font-medium text-muted-foreground mb-2">{t('request.id.label')}</div>
      <div className="bg-green-100 text-green-800 px-4 py-3 rounded-md font-medium">{consignmentId}</div>
    </div>
  );
}
